import { monthIndexToName } from "./monthIndexToName";


export const dateConvertedLib = {
    monthIndexToName,
};